// extracted by mini-css-extract-plugin
module.exports = {"input":"deleteModal_input_1ZVx9","inputContainer":"deleteModal_inputContainer_3SYc4"};